import {
  fetchAll,
  fetchFiltered,
  add,
  edit,
  show,
  suspendEmail
} from '@/api/stockalerts'

const state = {
  all           : [],
  isLoading     : false,
  stockAlertById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const stockAlert = await fetchAll()
      commit('setAll', stockAlert)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const stockAlert = await show(id)
      commit('setStockAlertById', stockAlert)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const stockAlert = await fetchFiltered(queriesParams)
      commit('setAll', stockAlert)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      const msg = e.message === 'alreadyExists'
        ? { message: 'Status já cadastrado!' }
        : e

      dispatch('notify/error', msg, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, status) {
    commit('setLoading', true)
    try {
      await add(status)
      return true
    } catch (e) {
      const msg = e.message === 'alreadyExists'
        ? { message: 'Status já cadastrado!' }
        : e

      dispatch('notify/error', msg, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async suspendEmail ({ dispatch }, { id, date }) {
    try {
      dispatch('overlay/show', { isShow: true, message: 'Suspendendo e-mail...' }, { root: true })

      await suspendEmail(id, { date })

      dispatch('notify/success', { message: 'E-mail suspenso!' }, { root: true })

      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })

      return false
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },
}

const mutations = {
  setAll (state, stockAlert) {
    state.all = stockAlert
  },

  setStockAlertById (state, stockAlert) {
    state.stockAlertById = stockAlert
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },

  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.stockAlertById = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
